<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit" @submit.prevent="create">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span v-if="!isDisplaySmall" class="text-h5">{{ header }}</span>
          <span v-if="isDisplaySmall">{{ headerMobile }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-container>
          <v-row style="display: block; margin-left: 12%; margin-right: 12%">
            <v-card outlined class="border card-info mt-2 mb-4">
              <div class="pa-4">
                <div v-for="(item, index) in basicInfoDevices" :key="index">
                  <LabelValueInfo
                    :label="item.label"
                    :value="item.value"
                    :check="item.check"
                    :br-check="item.brCheck"
                    :is-check-size-small="isDisplaySmall"
                  />
                </div>
              </div>
            </v-card>
            <div class="grid-container">
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="name"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-rename-box-outline"
                  label="Название"
                  :maxlength=64
                  type="string"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="code"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-key-outline"
                  label="Код ключа"
                  type="number"
                  :rules="[
                    () => !!code || 'Обязательное поле',
                  ]"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="serialNumber"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-cog-outline"
                  label="Серийный номер"
                  :rules="[
                    () => !!code || 'Обязательное поле',
                  ]"
                  type="string"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="comment"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-comment-outline"
                  label="Комментрарий / ФИО"
                  :maxlength=64
                  type="string"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
            </div>
          </v-row>
        </v-container>
        <div style="display: block; text-align: center;">
          <v-btn
            outlined
            class="text-none mt-3 px-2 btn-completion"
            rounded
            @click="create"
          >
            Завершить оформление
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify">
              <p class="text-info">
                Документы необходимые от клиента: паспорт, а также
                один из нижеперечисленных документов:
                <br><br>
                1.Постоянная регистрация по указанному адресу;<br>
                2.Выписка из ЕГРН или договор долевого участия +
                акт приёма передачи или расписка Росреестра в получении
                документов на регистрацию права собственности;<br>
                3.Нотариально заверенная доверенность от собственника,
                если заключает договор или получает ключи не собственник.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';
import LabelValueInfo from '@/components/LabelValueInfo';

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    header: String,
    headerMobile: String,
    icon: String,
    basicInfoDevices: {
      type: Array,
      required: true,
    },
  },
  components: { LabelValueInfo },
  data: () => ({
    valid: true,
    name: '',
    code: null,
    serialNumber: '',
    loading: false,
    isDisplaySmall: false,
    comment: '',
  }),
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  methods: {
    ...mapActions({
      createKeyGate: 'Gate/createKeyGate',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    create () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          this.loading = true;
          const data = {
            code: this.code,
            name: this.name,
            serial_number: this.serialNumber,
            comment: this.comment,
          };
          this.close();
          this.createKeyGate({
            id: this.$route.params.id,
            params: data,
          })
            .then(() => {
              this.$flash_success('Изменения успешно сохранены!');
              this.submit();
            })
            .catch((err) => {
              if (err.message.includes('422')) {
                const response = err.response.data;
                for (const input in response) {
                  response[input].forEach(error => this.$flash_warning(input + ': ' + error));
                }
              } else {
                this.$flash_warning('Ошибка, не удолось загрузить ключ');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
      this.cleaningTextField();
    },
    cleaningTextField () {
      this.name = '';
      this.code = null;
      this.comment = '';
      this.serialNumber = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card-title-reader {
  display: block;
  text-align: center;
}
.card-completion {
  display: flex;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(172, 204, 172, 0.5);
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 97.34px;
  max-height: 97.34px;
  text-align: center;
  background-color: #85B285;
}
.custom-icon {
  font-size: 48px;
  height: 100%;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  box-shadow: none;
  background-color: rgba(172, 204, 172, 0.5);
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.box-3 {
  grid-column: 1 / 3;
  grid-row: 2 / 3;
}
.box-5 {
  grid-column: 1 / 3;
  grid-row: 3 / 4;
}
.btn-completion {
  width: 100%;
  max-width: 250px;
  background-color: #85B285;
  color: white;
}
.border {
  border-radius: 16px;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .grid-container {
    display: block;
  }
  .card-title-reader {
    font-size: 16px;
    white-space: nowrap;
    padding: 11px;
  }
  .card-completion {
    display: block;
  }
  .text-info {
    padding: 20px;
  }
}
</style>
